export default __webpack_public_path__ + "static/media/36I-117127_-43588_0.685fa399.jpg";